import metaDataManager from './metaDataManager.js';

const getPixelData = imageId => Promise.resolve({
  imageFrame: {
    pixelData: new Uint8Array(metaDataManager.get('radPixelData', imageId))
  }
});

export default getPixelData;